module.exports = __webpack_public_path__ + "img/user-placeholder.6a1069ae.png";